"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeAnalytics = exports.getInitialAnalyticsProperties = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.array.concat.js");

var _fetchLanguage = require("./fetchLanguage");

var _fetchUrlLocation = require("./fetchUrlLocation");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * @name convertToDashName
 * @description Gets event name and converts it to dashed event name
 * @param {string} eventName - Event name
 * @returns {string}
 */
var convertToDashName = function convertToDashName(eventName) {
  return eventName.split(' ').map(function (word) {
    return word.toLowerCase();
  }).join('-');
};
/**
 * @name sendClickEvent
 * @description Call web shell analytics functions and sends click event
 * @param {SendClickEventOptions} args - Event options
 * @param {string} args.pageType - The type of page where the click event occurred.
 * @param {string} args.eventName - The name of the click event.
 * @param {Partial<WebShellAnalyticsEventOptions>} args.eventOptions - More options to include with the click event.
 * @returns {void}
 */


var sendClickEvent = function sendClickEvent(_ref) {
  var pageType = _ref.pageType,
      eventName = _ref.eventName,
      eventOptions = _ref.eventOptions;

  /* eslint-disable no-empty */
  try {
    var _window$webShellClien, _window$webShellClien2, _window$__shell, _window$__shell$analy;

    var eventDashName = convertToDashName(eventName);
    var schema = "https://www.nike.com/assets/measure/schemas/digital-product/dotcom/platform/web/classification/experience-event/experience/".concat(pageType, "/event-type/track/event-name/").concat(eventDashName, "/version/LATEST/schema.json");
    if (!((_window$webShellClien = window.webShellClient) !== null && _window$webShellClien !== void 0 && (_window$webShellClien2 = _window$webShellClien.analytics) !== null && _window$webShellClien2 !== void 0 && _window$webShellClien2.track) || !((_window$__shell = window.__shell) !== null && _window$__shell !== void 0 && (_window$__shell$analy = _window$__shell.analytics) !== null && _window$__shell$analy !== void 0 && _window$__shell$analy.writeKey)) return;
    window.webShellClient.analytics.track(eventName, _objectSpread({}, eventOptions), {
      $schema: schema,
      writeKey: window.__shell.analytics.writeKey
    });
  } catch (error) {}
};
/**
 * @name sendPageEvent
 * @description Call web shell analytics functions and sends page event
 * @param {SendPageEventOptions} args - Event options
 * @param {string} args.pageType - The type of page where the click event occurred.
 * @param {string} args.eventName - The name of the click event.
 * @param {Partial<WebShellAnalyticsEventOptions>} args.eventOptions - More options to include with the click event.
 * @param {string} args.pageName - The pageName of the event fired leading up to this event.
 * @returns {void}
 */


var sendPageEvent = function sendPageEvent(_ref2) {
  var pageType = _ref2.pageType,
      eventName = _ref2.eventName,
      eventOptions = _ref2.eventOptions,
      pageName = _ref2.pageName;

  /* eslint-disable no-empty */
  try {
    var _window$webShellClien3, _window$webShellClien4, _window$__shell2, _window$__shell2$anal;

    var eventDashName = convertToDashName(eventName);
    var schema = "https://www.nike.com/assets/measure/schemas/digital-product/dotcom/platform/web/classification/experience-event/experience/".concat(pageType, "/event-type/page/event-name/").concat(eventDashName, "/version/LATEST/schema.json");
    if (!((_window$webShellClien3 = window.webShellClient) !== null && _window$webShellClien3 !== void 0 && (_window$webShellClien4 = _window$webShellClien3.analytics) !== null && _window$webShellClien4 !== void 0 && _window$webShellClien4.page) || !((_window$__shell2 = window.__shell) !== null && _window$__shell2 !== void 0 && (_window$__shell2$anal = _window$__shell2.analytics) !== null && _window$__shell2$anal !== void 0 && _window$__shell2$anal.writeKey)) return;
    window.webShellClient.analytics.page(undefined, pageName, _objectSpread({
      eventName: eventName
    }, eventOptions), {
      $schema: schema,
      writeKey: window.__shell.analytics.writeKey
    });
  } catch (error) {}
};
/**
 * @name initializeAnalytics
 * @description Initialize analytics and returns object with analytics functions
 * @param {string} pageType - Page type
 * @returns {AnalyticsEventFunctions}
 */


var initializeAnalytics = function initializeAnalytics(pageType) {
  var pageViewed = function pageViewed(pageName, eventName) {
    var eventOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    sendPageEvent({
      pageName: pageName,
      pageType: pageType,
      eventName: eventName,
      eventOptions: eventOptions
    });
  };

  var trackClick = function trackClick(eventName) {
    var eventOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    sendClickEvent({
      pageType: pageType,
      eventName: eventName,
      eventOptions: eventOptions
    });
  };

  return {
    trackClick: trackClick,
    pageViewed: pageViewed
  };
};
/**
 @name getInitialAnalyticsProperties
 @description Returns an object with properties
 @param {GetInitialAnalyticsPropertiesOptions} args - Event options
 @param {string} args.pageName - The pageName of the event fired leading up to this event.
 @param {string} args.viewPageType - The type of page where the click event occurred.
 @param {string} args.pageDetail - Name of the page where the event took place. The last level of the page name
 @returns {GeneralAnalyticsEventOptions}
 */


exports.initializeAnalytics = initializeAnalytics;

var getInitialAnalyticsProperties = function getInitialAnalyticsProperties(_ref3) {
  var _window, _window$location;

  var pageName = _ref3.pageName,
      viewPageType = _ref3.viewPageType,
      pageDetail = _ref3.pageDetail;
  var properties = {
    app: {
      backendPlatform: 'cloud',
      version: '1.0.0',
      domain: (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.hostname
    },
    locale: {
      country: (0, _fetchUrlLocation.fetchUrlLocation)(),
      language: (0, _fetchLanguage.fetchLanguage)()
    },
    view: {
      experienceType: 'nikecom',
      pageName: pageName,
      pageType: viewPageType
    }
  };
  if (pageDetail) properties.view.pageDetail = pageDetail;
  return properties;
};

exports.getInitialAnalyticsProperties = getInitialAnalyticsProperties;